import { API } from "../config";
import { getCookie } from "../actions/auth";
import { requestWrapper } from "../utils/api";

export const getTextItems = () => {
  const token = getCookie("token");

  return requestWrapper(
    fetch(`${API}/project/render/getTextItems`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "x-access-token": token,
      },
    })
  );
};
export const getPdfDefaultItems = () => {
  const token = getCookie("token");

  return requestWrapper(
    fetch(`${API}/project/render/getPdfDefaultItems`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "x-access-token": token,
      },
    })
  );
};
